import React from "react";

export default function DashboardStatusCard({
  subscriptionInfo,
  subscriptionLoading,
  theme = "dark",
}) {
  const isDark = theme === "dark";

  const hasPaidAccess = subscriptionInfo?.hasActiveSubscription || false;
  const isAdmin = subscriptionInfo?.isAdmin || false;
  const isInternalTeam = subscriptionInfo?.isInternalTeam || false;
  const isAdminBypass = subscriptionInfo?.isAdminBypass || false;
  const freeUploadsRemaining = subscriptionInfo?.freeUploadsRemaining || 0;
  const subscription = subscriptionInfo?.subscription || null;

  let title = "Free Trial";
  let message = `${freeUploadsRemaining} free upload remaining. Demo dashboards are available for everyone.`;
  let badge = "TRIAL";
  let accent = "#f59e0b";
  let bg = isDark ? "rgba(245,158,11,0.12)" : "#fffbeb";
  let border = isDark ? "rgba(245,158,11,0.35)" : "#fcd34d";

  if (subscriptionLoading) {
    title = "Checking Access";
    message = "Please wait while we check your subscription and access status.";
    badge = "LOADING";
    accent = "#60a5fa";
    bg = isDark ? "rgba(96,165,250,0.12)" : "#eff6ff";
    border = isDark ? "rgba(96,165,250,0.35)" : "#93c5fd";
  } else if (isAdmin) {
    title = "Admin Access Enabled";
    message = "You have full access, including dashboard, upload, export, reports, and user access management.";
    badge = "ADMIN";
    accent = "#8b5cf6";
    bg = isDark ? "rgba(139,92,246,0.14)" : "#f5f3ff";
    border = isDark ? "rgba(139,92,246,0.35)" : "#c4b5fd";
  } else if (isInternalTeam || isAdminBypass) {
    title = "Internal Team Access Enabled";
    message = "You have full dashboard access without payment. Admin controls are available only to admin users.";
    badge = "INTERNAL";
    accent = "#10b981";
    bg = isDark ? "rgba(16,185,129,0.12)" : "#ecfdf5";
    border = isDark ? "rgba(16,185,129,0.35)" : "#6ee7b7";
  } else if (hasPaidAccess) {
    title = "Subscription Active";
    message = `Your ${subscription?.plan || "Starter"} plan is active${
      subscription?.expiryDate
        ? ` until ${new Date(subscription.expiryDate).toLocaleDateString()}`
        : ""
    }.`;
    badge = "PAID";
    accent = "#22c55e";
    bg = isDark ? "rgba(34,197,94,0.12)" : "#f0fdf4";
    border = isDark ? "rgba(34,197,94,0.35)" : "#86efac";
  } else if (freeUploadsRemaining <= 0) {
    title = "Trial Used";
    message = "Your free upload trial is finished. Upgrade to Starter to continue uploading files, saving reports, exporting PDF, and printing.";
    badge = "UPGRADE";
    accent = "#ef4444";
    bg = isDark ? "rgba(239,68,68,0.12)" : "#fef2f2";
    border = isDark ? "rgba(239,68,68,0.35)" : "#fecaca";
  }

  const textColor = isDark ? "#f8fafc" : "#111827";
  const mutedColor = isDark ? "#cbd5e1" : "#4b5563";

  return (
    <div
      style={{
        marginTop: 18,
        marginBottom: 18,
        padding: 18,
        borderRadius: 20,
        border: `1px solid ${border}`,
        background: bg,
        color: textColor,
        boxShadow: isDark
          ? "0 12px 30px rgba(0,0,0,0.25)"
          : "0 12px 30px rgba(15,23,42,0.08)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "6px 10px",
              borderRadius: 999,
              background: accent,
              color: "#ffffff",
              fontWeight: 900,
              fontSize: 12,
              letterSpacing: "0.04em",
              marginBottom: 10,
            }}
          >
            {badge}
          </div>

          <h3
            style={{
              margin: "0 0 6px",
              fontSize: 20,
              fontWeight: 900,
            }}
          >
            {title}
          </h3>

          <p
            style={{
              margin: 0,
              color: mutedColor,
              lineHeight: 1.6,
              fontSize: 14,
            }}
          >
            {message}
          </p>
        </div>

        {!hasPaidAccess && !isAdminBypass && !subscriptionLoading ? (
          <div
            style={{
              minWidth: 160,
              padding: 14,
              borderRadius: 16,
              background: isDark ? "rgba(15,23,42,0.65)" : "#ffffff",
              border: `1px solid ${border}`,
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 28,
                fontWeight: 900,
                color: accent,
              }}
            >
              {freeUploadsRemaining}
            </div>
            <div
              style={{
                color: mutedColor,
                fontSize: 12,
                fontWeight: 800,
                textTransform: "uppercase",
              }}
            >
              Free Uploads Left
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}